import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import badgePillVariants from './variants'

function BadgePill({ className, children, variant = 'default' }) {
  const variantClasses = {
    'bg-primary-lighten-20': variant === 'default',
    'bg-white border border-primary': variant === 'outline-white',
    'bg-primary border border-primary text-white': variant === 'primary',
    'bg-primary-lighten-20 border border-primary': variant === 'filled',
    'bg-primary-light border border-primary': variant === 'outline-primary',
    'bg-gray-4 text-dark border border-secondary': variant === 'disabled',
  }

  // If no variant matches, use default
  if (!Object.values(variantClasses).some(Boolean)) {
    variantClasses['bg-primary-lighten-20'] = true
  }

  const cls = classNames(className, variantClasses, 'badge badge-pill')
  return <span className={cls}>{children}</span>
}

BadgePill.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  variant: PropTypes.string,
}

export default BadgePill
export { badgePillVariants }
